import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import posthog from 'posthog-js';

posthog.init('phc_GBAVpSTpklPfM4wu4u9IyWgP4itzB81WcLJkARqpVbg', {
  api_host: 'https://us.i.posthog.com',
  capture_pageview: 'history_change',
});

posthog.register({
  app_url: window.__CONFIG__?.APP_URL,
  app_name: window.__CONFIG__?.APP_NAME,
  client: window.__CONFIG__?.APP_CLIENT,
  environment: window.__CONFIG__?.APP_ENVIRONMENT,
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
